import { Grid, Typography } from "@material-ui/core";
import InputBase from "@material-ui/core/InputBase";
import { makeStyles } from "@material-ui/core/styles";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import SearchIcon from "@material-ui/icons/Search";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import {
  Link,
  Route,
  Switch,
  useLocation,
  useRouteMatch,
} from "react-router-dom";
import GettingStartedTopics from "../studenthelptopics/GettingsStartedTopics";
import TakingAssessmentsTopics from "../studenthelptopics/TakingAssessmentsTopics";
import AnswerSheetsTopics from "../teacherhelptopics/AnswerSheetsTopics";
import CreateAnswerKeyTopics from "../teacherhelptopics/CreateAnswerKeyTopics";
import HandwritingTopics from "../teacherhelptopics/HandwritingTopics";
import KeyIdeaTopics from "../teacherhelptopics/KeyIdeaTopics";
import ViewandSend from "../teacherhelptopics/ViewandSend";
import { studentArticles, teacherArticles } from "./Help";
import DifferentAnswerTopics from "../teacherhelptopics/DifferentAnswerTopics";
import ScanningPaperTopics from "../teacherhelptopics/ScanningPaperTopics";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& ul": {
      padding: "0px",
    },
  },

  faqTopics: {
    backgroundColor: "#f7f7f7",
    height: "100vh",
    paddingLeft: "50px",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    overflow: "scroll",

    "& li": {
      color: "#646f79",
      listStyleType: "none",
      margin: "5px 0px",
      fontWeight: "600",
      fontSize: "14px",
      padding: "5px ",
    },
    "& li:hover": {
      color: "#9287FF",
      boxShadow: "-3px 0 0 0 #9287FF",
      cursor: "pointer",
    },
    "& li.active": {
      color: "#9287FF",
      boxShadow: "-3px 0 0 0 #9287FF",
    },
    [theme.breakpoints.down("xs")]: {
      height: "auto",
      paddingTop: "20px",
      paddingLeft: "10px",
    },
  },
  faqWrapper: {
    paddingTop: "60px",
    position: "sticky",
    height: `calc(100% )`,
    color: "#151b26",
    [theme.breakpoints.down("xs")]: {
      position: "relative",
      padding: "0 10px",
    },
  },
  fontHeading: {
    color: "#646f79",
    textDecoration: "underline",
    fontWeight: 700,
  },
  hyperlink: {
    color: "#8277FF !important",
    textDecoration: "none",
  },
  search: {
    borderRadius: theme.shape.borderRadius,
    boxShadow: "0 0 0 1.5px #646f79",
    display: "flex",
    flexWrap: "nowrap",
    margin: "10px 20px 40px 0px",
  },
  searchIcon: {
    height: "100%",
    position: "relative",
    display: "flex",
    alignSelf: "center",
    right: "10px",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
  },
  categoryMain: {
    width: "100%",
    height: `calc(100vh )`,
    overflow: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    paddingLeft: "30px",
    paddingBottom: "30px",
    paddingRight: "30px",
    color: "#151b26",
    [theme.breakpoints.down("xs")]: {
      height: "auto",
      overflow: "visible",
    },
  },
  subCat: {
    textDecoration: "underline",
    color: "#646f79",
    margin: "10px 0px",
  },
  breadcrumb: {
    fontSize: "14px",
    color: "#9287FF",
    textDecoration: "none",
  },
  arrowIcon: {
    fontSize: "14px",
    color: "#9287FF",
    margin: "0px 7px",
  },
}));

function KeyIdeasSide() {
  const { url } = useRouteMatch();
  const location = useLocation();
  const { pathname } = location;

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <ul id="topicList">
        <Typography variant="subtitle1" className={classes.subCat}>
          General info
        </Typography>
        {teacherArticles
          .filter((article) => article.Category === "Key ideas")
          .map((article, index) => {
            return (
              <div key={index}>
                <Link
                  to={`${url}/key-idea-topics/${article.Link}`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes(`${article.Link}`) ? "active" : ""
                    }
                  >
                    {article.Topic}
                  </li>
                </Link>
              </div>
            );
          })}
      </ul>
    </div>
  );
}
function CreateAnswerKeySide() {
  const { url } = useRouteMatch();
  const location = useLocation();
  const { pathname } = location;

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <ul>
        <Typography variant="subtitle1" className={classes.subCat}>
          General info
        </Typography>
        {teacherArticles
          .filter(
            (article) =>
              article.Category === "Creating an answer key" &&
              article.SubCategory === "General info"
          )
          .map((article, index) => {
            return (
              <div key={index}>
                <Link
                  to={`${url}/create-answer-key-topics/${article.Link}`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes(`${article.Link}`) ? "active" : ""
                    }
                  >
                    {article.Topic}
                  </li>
                </Link>
              </div>
            );
          })}
      </ul>
      <ul>
        <Typography variant="subtitle1" className={classes.subCat}>
          Inputting answers
        </Typography>
        {teacherArticles
          .filter(
            (article) =>
              article.Category === "Creating an answer key" &&
              article.SubCategory === "Inputting answers"
          )
          .map((article, index) => {
            return (
              <div key={index}>
                <Link
                  to={`${url}/create-answer-key-topics/${article.Link}`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes(`${article.Link}`) ? "active" : ""
                    }
                  >
                    {article.Topic}
                  </li>
                </Link>
              </div>
            );
          })}
      </ul>
      <ul>
        <Typography variant="subtitle1" className={classes.subCat}>
          Tips and tricks
        </Typography>
        {teacherArticles
          .filter(
            (article) =>
              article.Category === "Creating an answer key" &&
              article.SubCategory === "Tips and tricks"
          )
          .map((article, index) => {
            return (
              <div key={index}>
                <Link
                  to={`${url}/create-answer-key-topics/${article.Link}`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes(`${article.Link}`) ? "active" : ""
                    }
                  >
                    {article.Topic}
                  </li>
                </Link>
              </div>
            );
          })}
      </ul>
    </div>
  );
}
function DifferentAnswerTypesSide() {
  const { url } = useRouteMatch();
  const location = useLocation();
  const { pathname } = location;

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <ul>
        {teacherArticles
          .filter(
            (article) => article.Category === "Our different answer types"
          )
          .map((article, index) => {
            return (
              <div key={index}>
                <Link
                  to={`${url}/different-answer-types/${article.Link}`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes(`${article.Link}`) ? "active" : ""
                    }
                  >
                    {article.Topic}
                  </li>
                </Link>
              </div>
            );
          })}
      </ul>
    </div>
  );
}
function AnswerSheetsSide() {
  const { url } = useRouteMatch();
  const location = useLocation();
  const { pathname } = location;

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <ul>
        <Typography variant="subtitle1" className={classes.subCat}>
          General info
        </Typography>
        {teacherArticles
          .filter(
            (article) =>
              article.Category === "Answer sheets" &&
              article.SubCategory === "General info"
          )
          .map((article, index) => {
            return (
              <div key={index}>
                <Link
                  to={`${url}/answer-sheet-topics/${article.Link}`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes(`${article.Link}`) ? "active" : ""
                    }
                  >
                    {article.Topic}
                  </li>
                </Link>
              </div>
            );
          })}
      </ul>
      <ul>
        <Typography variant="subtitle1" className={classes.subCat}>
          Paper answer sheets
        </Typography>
        {teacherArticles
          .filter(
            (article) =>
              article.Category === "Answer sheets" &&
              article.SubCategory === "Paper answer sheets"
          )
          .map((article, index) => {
            return (
              <div key={index}>
                <Link
                  to={`${url}/answer-sheet-topics/${article.Link}`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes(`${article.Link}`) ? "active" : ""
                    }
                  >
                    {article.Topic}
                  </li>
                </Link>
              </div>
            );
          })}
      </ul>
      <ul>
        <Typography variant="subtitle1" className={classes.subCat}>
          Online answer sheets:{" "}
        </Typography>
        {teacherArticles
          .filter(
            (article) =>
              article.Category === "Answer sheets" &&
              article.SubCategory === "Online answer sheets"
          )
          .map((article, index) => {
            return (
              <div key={index}>
                <Link
                  to={`${url}/answer-sheet-topics/${article.Link}`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes(`${article.Link}`) ? "active" : ""
                    }
                  >
                    {article.Topic}
                  </li>
                </Link>
              </div>
            );
          })}
      </ul>
    </div>
  );
}
function ScanningPaperAnswerSheetsSide() {
  const { url } = useRouteMatch();
  const location = useLocation();
  const { pathname } = location;

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <ul>
        {teacherArticles
          .filter(
            (article) => article.Category === "Scanning paper answer sheets"
          )
          .map((article, index) => {
            return (
              <div key={index}>
                <Link
                  to={`${url}/scanning-paper-answer-sheets-topics/${article.Link}`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes(`${article.Link}`) ? "active" : ""
                    }
                  >
                    {article.Topic}
                  </li>
                </Link>
              </div>
            );
          })}
      </ul>
    </div>
  );
}
function ViewandSendSide() {
  const { url } = useRouteMatch();
  const location = useLocation();
  const { pathname } = location;

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <ul>
        <Typography variant="subtitle1" className={classes.subCat}>
          General info
        </Typography>
        {teacherArticles
          .filter(
            (article) =>
              article.Category === "View and send results" &&
              article.SubCategory === "General info"
          )
          .map((article, index) => {
            return (
              <div key={index}>
                <Link
                  to={`${url}/view-and-send/${article.Link}`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes(`${article.Link}`) ? "active" : ""
                    }
                  >
                    {article.Topic}
                  </li>
                </Link>
              </div>
            );
          })}
      </ul>
      <ul>
        <Typography variant="subtitle1" className={classes.subCat}>
          Actions
        </Typography>
        {teacherArticles
          .filter(
            (article) =>
              article.Category === "View and send results" &&
              article.SubCategory === "Actions"
          )
          .map((article, index) => {
            return (
              <div key={index}>
                <Link
                  to={`${url}/view-and-send/${article.Link}`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes(`${article.Link}`) ? "active" : ""
                    }
                  >
                    {article.Topic}
                  </li>
                </Link>
              </div>
            );
          })}
      </ul>
      <ul>
        <Typography variant="subtitle1" className={classes.subCat}>
          Tips and tricks
        </Typography>
        {teacherArticles
          .filter(
            (article) =>
              article.Category === "View and send results" &&
              article.SubCategory === "Tips and tricks"
          )
          .map((article, index) => {
            return (
              <div key={index}>
                <Link
                  to={`${url}/view-and-send/${article.Link}`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes(`${article.Link}`) ? "active" : ""
                    }
                  >
                    {article.Topic}
                  </li>
                </Link>
              </div>
            );
          })}
      </ul>
    </div>
  );
}
function HandwritingSide() {
  const { url } = useRouteMatch();
  const location = useLocation();
  const { pathname } = location;

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <ul>
        {teacherArticles
          .filter(
            (article) => article.Category === "Handwriting recognition accuracy"
          )
          .map((article, index) => {
            return (
              <div key={index}>
                <Link
                  to={`${url}/handwriting-topics/${article.Link}`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes(`${article.Link}`) ? "active" : ""
                    }
                  >
                    {article.Topic}
                  </li>
                </Link>
              </div>
            );
          })}
      </ul>
    </div>
  );
}
function GettingStartedSide() {
  const { url } = useRouteMatch();
  const location = useLocation();
  const { pathname } = location;

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <ul>
        <Typography variant="subtitle1" className={classes.subCat}>
          General info
        </Typography>
        {studentArticles
          .filter((article) => article.Category === "Getting started")
          .map((article, index) => {
            return (
              <div key={index}>
                <Link
                  to={`${url}/getting-started-topics/${article.Link}`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes(`${article.Link}`) ? "active" : ""
                    }
                  >
                    {article.Topic}
                  </li>
                </Link>
              </div>
            );
          })}
      </ul>
    </div>
  );
}
function TakingAssessmentsSide() {
  const { url } = useRouteMatch();
  const location = useLocation();
  const { pathname } = location;

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <ul>
        <Typography variant="subtitle1" className={classes.subCat}>
          General info
        </Typography>
        {studentArticles
          .filter((article) => article.Category === "Taking assessments")
          .map((article, index) => {
            return (
              <div key={index}>
                <Link
                  to={`${url}/taking-assessments-topics/${article.Link}`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes(`${article.Link}`) ? "active" : ""
                    }
                  >
                    {article.Topic}
                  </li>
                </Link>
              </div>
            );
          })}
      </ul>
    </div>
  );
}

function HelpOptions() {
  const [topicCat, setTopicCat] = useState("");
  const [topicLink, setTopicLink] = useState("");
  const [val, setVal] = useState({});

  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    if (pathname.includes("handwriting-topics")) {
      setTopicCat("Handwriting accuracy");
      setTopicLink("help-options/handwriting-rec");
    } else if (pathname.includes("view-and-send")) {
      setTopicCat("View and send results");
      setTopicLink("help-options/view-results");
    } else if (pathname.includes("answer-sheet-topics")) {
      setTopicCat("Answer sheets");
      setTopicLink("help-options/answer-sheets");
    } else if (pathname.includes("scanning-paper-answer-sheets-topics")) {
      setTopicCat("Scanning paper answer sheets");
      setTopicLink("help-options/scanning-paper-answer-sheets");
    } else if (pathname.includes("create-answer-key-topics")) {
      setTopicCat("Creating an answer key");
      setTopicLink("help-options/create-answer-key");
    } else if (pathname.includes("different-answer-types")) {
      setTopicCat("Different answer types");
      setTopicLink("help-options/different-answers-types");
    } else if (pathname.includes("taking-assessments-topics")) {
      setTopicCat("Taking assessments");
      setTopicLink("student-help/taking-assessments");
    } else if (pathname.includes("getting-started")) {
      setTopicCat("Getting started");
      setTopicLink("student-help/getting-started");
    } else {
      setTopicCat("Key ideas");
      setTopicLink("help-options/key-ideas");
    }
    scrollToTopSection();
    setVal("");
  }, [pathname]);

  function renderSide() {
    if (pathname.includes("handwriting-topics")) {
      return <HandwritingSide />;
    } else if (pathname.includes("view-and-send")) {
      return <ViewandSendSide />;
    } else if (pathname.includes("answer-sheet-topics")) {
      return <AnswerSheetsSide />;
    } else if (pathname.includes("scanning-paper-answer-sheets-topics")) {
      return <ScanningPaperAnswerSheetsSide />;
    } else if (pathname.includes("create-answer-key-topics")) {
      return <CreateAnswerKeySide />;
    } else if (pathname.includes("different-answer-types-topics")) {
      return <DifferentAnswerTypesSide />;
    } else if (pathname.includes("getting-started-topics")) {
      return <GettingStartedSide />;
    } else if (pathname.includes("taking-assessments-topics")) {
      return <TakingAssessmentsSide />;
    } else {
      return <KeyIdeasSide />;
    }
  }

  const { path } = useRouteMatch();

  const scrollToTopSection = () => {
    document.getElementById("scrollMain").scroll(0, 0);
  };

  const allOptions = [...teacherArticles, ...studentArticles];

  const classes = useStyles();

  return (
    <>
      <Helmet>
        <title>
          Help Topics, Tips and Resources to Learn More About SwiftGrade
        </title>
        <meta
          name="description"
          content="SwiftGrade can grade both paper and online assessments making it great for virtual, in-person, or hybrid learning. Helping teachers reduce grading load for handwritten assessments by 80-90%."
        />
      </Helmet>
      <div className={classes.root}>
        <Grid container>
          <Grid item xs={12} sm={3} className={classes.faqTopics}>
            <div className={classes.faqWrapper}>
              <Grid container direction="row" alignItems="center">
                <Link to={`/`} className={classes.breadcrumb}>
                  Help Center
                </Link>
                <ArrowForwardIcon className={classes.arrowIcon} />
                <Link to={`/${topicLink}`} className={classes.breadcrumb}>
                  <span className={classes.breadcrumb}>{topicCat}</span>
                </Link>
              </Grid>

              <Autocomplete
                clearOnEscape
                key={val}
                clearOnBlur
                selectOnFocus
                id="complete"
                options={allOptions}
                openOnFocus={true}
                getOptionLabel={(option) => option.Topic}
                renderOption={(option) => (
                  <div
                    style={{
                      width: "100%",
                    }}
                  >
                    <Link
                      style={{
                        width: "100%",
                        color: "black",
                        textDecoration: "none",
                      }}
                      onClick={() => setVal(`${Math.random()}`)}
                      to={`/help-topics/${option.Sublink}/${option.Link}`}
                    >
                      <div
                        style={{
                          width: "100%",
                        }}
                      >
                        {option.Topic}
                      </div>
                    </Link>
                  </div>
                )}
                renderInput={(params) => (
                  <div ref={params.InputProps.ref} className={classes.search}>
                    <InputBase
                      {...params.inputProps}
                      placeholder="Search"
                      classes={{
                        root: classes.inputRoot,
                        input: classes.inputInput,
                      }}
                      inputProps={{ "aria-label": "search" }}
                    />
                    <div className={classes.searchIcon}>
                      <SearchIcon />
                    </div>
                  </div>
                )}
              />
              {renderSide()}
            </div>
          </Grid>
          <Grid
            id="scrollMain"
            item
            xs={12}
            sm={9}
            className={classes.categoryMain}
          >
            <Switch>
              <Route path={`${path}/key-idea-topics`}>
                <KeyIdeaTopics />
              </Route>
              <Route path={`${path}/view-and-send`}>
                <ViewandSend />
              </Route>
              <Route path={`${path}/answer-sheet-topics`}>
                <AnswerSheetsTopics />
              </Route>
              <Route path={`${path}/scanning-paper-answer-sheets-topics`}>
                <ScanningPaperTopics />
              </Route>
              <Route path={`${path}/create-answer-key-topics`}>
                <CreateAnswerKeyTopics />
              </Route>
              <Route path={`${path}/different-answer-types-topics`}>
                <DifferentAnswerTopics />
              </Route>
              <Route path={`${path}/handwriting-topics`}>
                <HandwritingTopics />
              </Route>
              <Route path={`${path}/getting-started-topics`}>
                <GettingStartedTopics />
              </Route>
              <Route path={`${path}/taking-assessments-topics`}>
                <TakingAssessmentsTopics />
              </Route>
              <Route>
                <TakingAssessmentsTopics />
              </Route>
            </Switch>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
export default HelpOptions;
